(ns quuppa.qsm.deployment.view
  (:require [re-frame.core :as rf]
            ["react" :as react]
            [linked.core :as l]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            [quuppa.peweb.query :as q]
            [quuppa.peweb.tables :as tables]
            [quuppa.qsm.deployment.events :as e]
            [quuppa.routing :refer [use-subscriptions]]
            [quuppa.qsm.ui-state.events :as ui-state]
            [quuppa.qsm.ui-state.subs :as ui-subs]
            [quuppa.ui.layout :as layout]
            [quuppa.ui.dropdown :as dropdown]
            [quuppa.qsm.features :as features]))

(defn new-deployment-form [site-plan-key]
  (let [form-key :form
        {:keys [target-email description]
         form-sp-key :site-plan-key} @(rf/subscribe [::ui-subs/ui-state :site :sidebar form-key])
        error @(rf/subscribe [::ui-subs/ui-state :site :sidebar :error])
        malli-error (get-in error [:ex-data :malli-error])]
    [layout/sidebar
     [layout/sidebar-header
      {:title "New deployment"
       :on-close #(rf/dispatch [::ui-state/update :site dissoc :sidebar])}]

     [layout/sidebar-content
      [:form.mb-4
       {:on-submit (fn [e]
                     (.preventDefault e)
                     (rf/dispatch [:deployment/create-deployment form-key site-plan-key]))}
       [:div.form-group
        [:label "Project key *"]
        (if (seq site-plan-key)
          [:input.form-control-plaintext
           {:type "text"
            :value site-plan-key
            :read-only true}]
          [:input.form-control
           {:type "text"
            :class [(when (:site-plan-key malli-error) "is-invalid")]
            :required true
            :value form-sp-key
            :on-change #(rf/dispatch [::ui-state/assoc-in [:site :sidebar form-key :site-plan-key] (.. % -target -value)])}])
        (when-let [e (:site-plan-key malli-error)]
          [:span.form-text.text-danger
           (first e)])]

       [:div.form-group
        [:label "Deployer’s email *"]
        [:input.form-control
         {:type "text"
          :class [(when (:target-email malli-error) "is-invalid")]
          :required true
          :value target-email
          :on-change #(rf/dispatch [::ui-state/assoc-in [:site :sidebar form-key :target-email] (.. % -target -value)])}]
        (when-let [e (:target-email malli-error)]
          [:span.form-text.text-danger
           (first e)])]

       [:div.form-group
        [:label "Notes"]
        [:textarea.form-control
         {:value description
          :on-change #(rf/dispatch [::ui-state/assoc-in [:site :sidebar form-key :description] (.. % -target -value)])}]]

       [:div
        [:button.btn.btn-primary
         {:type "submit"
          :disabled (some empty? [(or site-plan-key form-sp-key) target-email])}
         "Create and send email"]]]
      [c/error-msg error]]]))

(def deployment-columns
  (l/map
    :target-email
    {:value-fn :target-email
     :sortable true
     :width "25%"
     :label "Email"}

    :description
    {:value-fn :description
     :sortable true
     :width "50%"
     :label "Notes"}

    :expiry-date
    {:value-fn :expiry-date
     :sortable true
     :width "25%"
     :label "Expires"}

    :actions
    {:value-fn :qmd-link
     :sortable false
     :width 50
     :label ""}))

(rf/reg-sub
  ::sorted-deployments
  (fn [[_ site-plan-key _ _]]
    (q/subscribe e/deployments-query {:site-plan-key site-plan-key} [:result]))
  (fn [deployments [_ _site-plan-key sort-key sort-order]]
    (let [column (get deployment-columns sort-key)]
      (sort-by (:value-fn column)
               (if sort-order compare #(compare %2 %1))
               deployments))))

(defn deployments-table [site-plan-key owner-or-admin?]
  (let [[sort-key set-sort-key] (react/useState :expiry-date)
        [sort-order-asc set-sort-order-asc] (react/useState false)

        deployments @(rf/subscribe [::sorted-deployments site-plan-key sort-key sort-order-asc])]
    (react/useEffect (fn []
                       (q/execute e/deployments-query {:site-plan-key site-plan-key})
                       ;; Cleanup function
                       (fn []))
                     #js [site-plan-key])
    (use-subscriptions (when site-plan-key
                         [[:deployment/add {:site-plan-key site-plan-key}]
                          [:deployment/remove {:site-plan-key site-plan-key}]])
                       #js [site-plan-key])
    (if (seq deployments)
      [:table.table.table-bordered.table-striped
       [tables/thead
        {:columns deployment-columns
         :sort-key sort-key
         :sort-order-asc sort-order-asc
         :toggle-sort-order (fn [] (set-sort-order-asc not))
         :set-sort-key (fn [k]
                         (set-sort-key k)
                         (set-sort-order-asc true))}]
       [:tbody
        (for [{:keys [id target-email expiry-date expired description]} deployments]
          [:tr
           {:key id}
           [:td target-email]
           [:td description]
           [:td
            [:span
             {:class [(when expired
                        "text-danger")]}
             (date-time/format-local-date expiry-date)]]
           [:td
            (when owner-or-admin?
              [dropdown/dropdown
               [dropdown/menu-icon-toggle]
               [dropdown/menu
                (when (features/enabled? :deployment-test-links)
                  [dropdown/item
                   {:target "new"
                    :href (str "/deployment-test-redirect/" id)}
                   "[TEST] Open QMD"])
                [dropdown/item
                 {:on-click (fn [_e]
                              (when (js/confirm "Are you sure?")
                                (rf/dispatch [:deployment/delete-deployment site-plan-key id])))}
                 "Remove"]]])]])]]
      [:div
       [:p "No deployments yet."]
       (when site-plan-key
         [:p "Start using Mobile Deployment Tool for your site by creating a deployment."])])))
